// extracted by mini-css-extract-plugin
module.exports = {"listItem":"advantages_listItem__GaH6x","list":"advantages_list__lAaa6","icon":"advantages_icon__8qu46","middleIcon":"advantages_middleIcon__EwkVk"};